// src/api/authFetch.js
export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(url, {
    ...options,
    headers,
    credentials: "same-origin",
  });

  // 401(미인증) 공통 처리
  //
  //  [변경 이유]
  //   비로그인 상태로 매물 상세를 보면 화면이 부수적으로 호출하는 API들이
  //   401을 반환하는데, 그때마다 경고창이 떠서 사용에 방해가 됐다.
  //   비로그인에게는 이미 서버(maskEstate)가 민감정보를 제거해 보내므로
  //   "일부 정보가 안 보이는 것"은 정상 동작이지 오류가 아니다.
  //
  //  [동작]
  //   · 토큰이 아예 없으면(비로그인) → 조용히 응답만 반환
  //   · 토큰이 있는데 401이면(만료·무효) → 경고 후 예외
  //   · silent: true 를 넘기면 항상 조용히 처리
  if (res.status === 401) {
    if (!token || options.silent) {
      return res;   // 호출부에서 res.ok 로 판단해 해당 항목만 비우면 된다
    }
    alert("로그인이 필요한 서비스 입니다!");
    throw new Error("unauthorized");
  }
  return res;
}